import React from  'react';
import Title from './Title';
import BridgeTable from './BridgeTable';
import Auction from './Auction';
import OffTableCards from './OffTableCards';
import BridgeControls from './BridgeControls';
import TurnControls from './TurnControls';
import Hints from './Hints';
import Footer from './Footer';
import './BridgeBoard.css';

// component.
const BridgeBoard: React.FC = () => {

    return (
        <div id="game-grid-container">
            <div id="item-playspace">
                <div id="item-title">
                    <Title />
                </div>
                <div id="div-game-controls">
                    <BridgeControls />
                </div>
                <div id="div-game-off-cards">
                    <OffTableCards />
                </div>
                <div id="item-game-table">
                    <BridgeTable />
                </div>
                <div id="item-turns">
                    <TurnControls />
                </div>
                <div id="div-game-auction">
                    <Auction />
                </div>
                <div>
                    <Hints />
                </div>
                <div id="item-footer">
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default BridgeBoard;